export const paymentAccounts = {
  // Stripe y Wompi son DOS integraciones, no dos opciones de la misma: cada
  // una tiene su pantalla y su cabecera. `tagline` es la línea que sitúa
  // (dónde cobra y con qué medios) y evita que alguien de España se pelee con
  // una pasarela colombiana.
  header: {
    stripe: {
      title: "Cobros con Stripe",
      tagline: "Tarjetas internacionales · España y la mayoría de países",
      description:
        "Conecta una o varias cuentas de Stripe y decide con cuál cobra cada anuncio.",
    },
    wompi: {
      title: "Cobros con Wompi",
      tagline: "Colombia · PSE, Nequi y tarjetas colombianas",
      description:
        "Conecta una o varias cuentas de Wompi y decide con cuál cobra cada anuncio.",
    },
    bold: {
      title: "Cobros con Bold",
      tagline: "Colombia y Perú · PSE, Nequi, Bancolombia y tarjetas",
      description:
        "Conecta una o varias cuentas de Bold y decide con cuál cobra cada anuncio.",
    },
    redsys: {
      title: "Cobros con Redsys",
      tagline: "España · El TPV virtual de tu banco",
      description:
        "Conecta el TPV virtual de tu banco y decide con qué cuenta cobra cada anuncio. El dinero llega directo a tu cuenta bancaria.",
      card: "TPV virtual de tu banco (España)",
    },
  },

  // Wompi en un sitio donde no aplica. La pasarela la decide el país del
  // ANUNCIO, no el del dueño: por eso se habla de alojamientos, no de ti.
  notAvailable: {
    title: "Wompi es para alojamientos en Colombia",
    text: "Wompi cobra en pesos colombianos con PSE, Nequi y tarjetas de Colombia. No tienes ningún alojamiento allí, así que aquí no hay nada que conectar.",
    hint: "Si publicas un alojamiento en Colombia, esta pantalla se abrirá sola.",
    button: "Ir a {provider}",
  },

  session: {
    title: "Tu sesión ha caducado",
    text: "No se ha perdido nada: tus cuentas de cobro siguen conectadas. Vuelve a entrar para verlas.",
    button: "Volver a entrar",
  },

  status: {
    ready: "Lista",
    incomplete: "Incompleta",
    unverified: "Sin verificar",
  },

  environment: {
    test: "Pruebas",
  },

  accounts: {
    card: {
      title: "Tus cuentas de {provider}",
      subtitle: "Conecta cuentas nuevas y revisa si están listas para cobrar.",
    },
    searchPlaceholder: "Buscar cuenta por nombre…",
    newButton: "Conectar cuenta de {provider}",
    noName: "Sin nombre",
    fallbackName: "Cuenta #{id}",
    defaultBadge: "Principal",
    listingsCount: "{count} anuncio | {count} anuncios",
    empty: {
      none: "Todavía no has conectado ninguna cuenta de {provider}.",
      noMatch: "Ninguna cuenta coincide con la búsqueda.",
    },
    actions: {
      edit: "Editar",
      setDefault: "Hacer principal",
      isDefault: "Ya es la principal",
      resume: "Continuar el alta",
      verify: "Verificar",
      disconnect: "Desconectar",
    },
  },

  assign: {
    card: {
      title: "Reparto por anuncio",
      subtitle: "Elige qué anuncios cobra cada cuenta de {provider}.",
    },
    searchPlaceholder: "Buscar anuncio por nombre…",
    filter: {
      all: "Todos",
      unassigned: "Sin asignar",
      notReady: "Sin poder cobrar",
      other: "Cobra por {provider}",
    },
    // Sin cuenta asignada. Cuando se sabe cuál es la principal se nombra, que
    // es lo que el anfitrión quiere saber: por qué cuenta cobra este anuncio.
    // Si le toca el otro proveedor (por el país del anuncio), se dice cuál:
    // callarlo sería dejarle creer que cobra por esta pasarela.
    autoOption: "Cuenta principal",
    autoOptionNamed: "Cuenta principal · {name}",
    autoOptionOther: "Cuenta principal de {provider} · {name}",
    // Anuncio enganchado a una cuenta de la otra pasarela: se ve, pero se
    // gestiona en su pantalla.
    otherProvider: "Cobra por {provider} · {name}",
    otherProviderLink: "Gestionar en {provider}",
    notReadyRow: "No puede cobrar",
    notReadyRowTip: "La cuenta asignada a este anuncio todavía no está lista, así que el huésped no podrá pagar.",
    notReadyAutoRow: "Tu cuenta principal no puede cobrar",
    notReadyAutoRowTip: "Este anuncio usa la cuenta principal, que todavía no está lista. Termínala o asígnale otra cuenta.",
    notReadyBanner: "{count} anuncio no puede cobrar ahora mismo: su cuenta todavía no está lista. Los huéspedes no podrán pagarlo hasta que la termines. | {count} anuncios no pueden cobrar ahora mismo: su cuenta todavía no está lista. Los huéspedes no podrán pagarlos hasta que la termines.",
    notReadyBannerLink: "Ver esos anuncios",
    defaultSuffix: " (principal)",
    empty: {
      none: "Todavía no tienes anuncios.",
      noMatch: "Ningún anuncio coincide con el filtro.",
    },
    count: "Se ven {shown} de {total} anuncios",
  },

  drawer: {
    newTitle: "Conectar una cuenta de {provider}",
    editTitle: "Editar la cuenta de {provider}",
    subtitle: "Ponle un nombre y elige qué anuncios cobra.",
    closeAria: "Cerrar el panel",

    stripe: {
      title: "Alta en Stripe",
      subtitle: "Stripe te pedirá tus datos y volverás aquí al terminar.",
      explain:
        "Te llevamos a Stripe para crear la cuenta con este nombre y verificar tus datos. Al volver podrás elegir qué anuncios cobra; si dejas el alta a medias, la cuenta te espera aquí para retomarla.",
      button: "Continuar en Stripe",
      connecting: "Abriendo Stripe…",
      resumeTitle: "Alta de Stripe a medias",
      resumeSubtitle: "Falta terminar la verificación en Stripe.",
      resumeExplain: "Esta cuenta se creó pero no llegó a terminar el alta en Stripe, por eso todavía no puede cobrar. Retómala y sigue donde lo dejaste.",
      resumeButton: "Continuar el alta",
    },

    data: {
      title: "Datos de la cuenta",
      subtitle: "El nombre es solo para ti: te ayuda a distinguirlas.",
      label: "Nombre de la cuenta",
      labelPlaceholder: "Por ejemplo: Apartamentos de la playa",
      labelHint: "El huésped no lo ve en ningún momento.",
      publicKey: "Clave pública",
      privateKey: "Clave privada",
      privateKeyKept: "Se conserva la que ya tenías",
      privateKeyHint: "Déjalo en blanco para seguir con la clave guardada.",
      stripeId: "Identificador de Stripe",
    },

    listings: {
      title: "Anuncios que cobra",
      subtitle: "Los que marques dejarán de cobrar con su cuenta anterior.",
      label: "Anuncios de esta cuenta",
      selectedCount: "{selected} de {total} marcados",
      searchPlaceholder: "Buscar anuncio…",
      selectAll: "Seleccionar todas",
      clear: "Limpiar",
      takenBy: "ahora en {name}",
      noResults: "Ningún anuncio coincide con la búsqueda.",
      hint: "Los anuncios que no marques en ninguna cuenta cobran con la principal.",
      otherHidden: "Aquí no sale {count} anuncio que cobra por {provider}: se gestiona en su pantalla. | Aquí no salen {count} anuncios que cobran por {provider}: se gestionan en su pantalla.",
    },

    footer: {
      isDefault: "Ya es la principal",
      setDefault: "Hacer principal",
      disconnect: "Desconectar",
      cancel: "Cancelar",
      save: "Guardar",
      saving: "Guardando…",
    },
  },

  disconnect: {
    title: "Desconectar la cuenta",
    subtitle: "Dejarás de cobrar con ella.",
    confirm:
      "Vas a desconectar «{name}». Las reservas que ya se cobraron no se tocan, pero esta cuenta dejará de aceptar pagos nuevos.",
    blocked:
      "«{name}» todavía cobra {count} anuncio. Antes de desconectarla hay que pasarlo a otra cuenta. | «{name}» todavía cobra {count} anuncios. Antes de desconectarla hay que pasarlos a otra cuenta.",
    moveLabel: "Mover esos anuncios a",
    moveHint:
      "Los pasamos a la cuenta que elijas y después desconectamos esta.",
    cancel: "Cancelar",
    accept: "Desconectar",
    seeListings: "Ver esos anuncios",
    moveAndDisconnect: "Mover y desconectar",
  },

  loading: {
    accounts: "Cargando tus cuentas de cobro…",
  },

  msg: {
    loadError: "No hemos podido cargar tus cuentas de cobro.",
    labelRequired: "Ponle un nombre a la cuenta.",
    publicKeyRequired: "Falta la clave pública de Wompi.",
    privateKeyRequired: "Falta la clave privada de Wompi.",
    saved: "Cuenta guardada.",
    saveError: "No hemos podido guardar la cuenta.",
    stripeNoUrl: "Stripe no nos ha devuelto el enlace de alta. Inténtalo otra vez.",
    stripeConnectError: "No hemos podido abrir el alta de Stripe.",
    verified: "La cuenta está verificada.",
    verifiedWithName: "Cuenta verificada: {name}.",
    notVerified: "La cuenta todavía no está verificada. Revisa las claves.",
    verifyError: "No hemos podido verificar la cuenta.",
    defaultUpdated: "Ya es la cuenta principal.",
    defaultError: "No hemos podido cambiar la cuenta principal.",
    disconnected: "Cuenta desconectada.",
    disconnectError: "No hemos podido desconectar la cuenta.",
    movedAndDisconnected: "Anuncios movidos y cuenta desconectada.",
    savedNotReady: "Ojo: esta cuenta todavía no puede cobrar y tiene {count} anuncio asignado. Termínala o ese anuncio se quedará sin cobrar. | Ojo: esta cuenta todavía no puede cobrar y tiene {count} anuncios asignados. Termínala o esos anuncios se quedarán sin cobrar.",
    assignError: "No hemos podido cambiar la cuenta de este anuncio.",
  },

  integrations: {
    connectedAccounts: "{count} cuenta conectada | {count} cuentas conectadas",
    notApplicable: "Para alojamientos en Colombia",
    notApplicableSpain: "Para alojamientos en España",
  },

  // Redsys: los tres datos del TPV que da el banco, y el entorno.
  redsys: {
    environment: "Entorno",
    environmentHint: "Tu banco te da unos datos para pruebas y otros para cobrar de verdad. Elige a cuál pertenecen los que vas a escribir.",
    env: {
      test: "Pruebas",
      prod: "Real",
    },
    merchantCode: "Número de comercio (FUC)",
    merchantCodeHint: "Lo tienes en el contrato del TPV o en el módulo de administración de Redsys. Son solo cifras, normalmente nueve.",
    terminal: "Terminal",
    terminalHint: "Casi siempre es 1. Si tu banco te dio varios, el del TPV virtual.",
    secretKey: "Clave de firma (SHA-256)",
    secretKeyHint: "En el módulo de administración de Redsys → Consulta datos de comercio → «Ver clave». La comprobamos con Redsys al guardar, sin cobrar nada.",
    onlyEuro: "Solo euros · cobra en {currency}",
    onlyEuroTip: "Redsys solo cobra en euros. Asigna este alojamiento a otra cuenta de cobro.",
    msg: {
      merchantCode: "El número de comercio son solo cifras (normalmente nueve).",
      terminal: "El terminal es un número de una a tres cifras (casi siempre 1).",
      secretKey: "Falta la clave de firma de Redsys.",
    },
  },
};
